import { FeatureProtectedView } from '@moniebook-web/components/molecules/feature-protected-view';

import { MenusLoadingSkeleton } from './menus-skeleton/menus-skeleton';
import { Sidebar as SidebarV1 } from './sidebar';
import { Sidebar as SidebarV2 } from './v2/app-sidebar';

export function Sidebar() {
    return (
        <FeatureProtectedView
            altView={<SidebarV1 />}
            loader={<MenusLoadingSkeleton />}
            flag='moniebook.pos.newSidebar'>
            <SidebarV2 />
        </FeatureProtectedView>
    );
}
